import { render, staticRenderFns } from "./Prestaciones.vue?vue&type=template&id=77ec6288&scoped=true&lang=pug&"
import script from "./Prestaciones.vue?vue&type=script&lang=js&"
export * from "./Prestaciones.vue?vue&type=script&lang=js&"
import style0 from "./Prestaciones.vue?vue&type=style&index=0&id=77ec6288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec6288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})
